import { Injectable } from '@angular/core';
import { HttpServices } from 'src/app/shared/services/http-service.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { Subject, Observable } from 'rxjs';



@Injectable({ providedIn: 'root' })
export class AgentService {

    private _listners = new Subject<any>();

    listen(): Observable<any> {
        return this._listners.asObservable();
    }

    filter(agentId: string) {
        this._listners.next(agentId);
    }


    constructor(private http: HttpServices) { }

    GetAgent(AgentId: string) {
        return this.http.get('Agent/GetAgent?AgentId=' + AgentId);
    }
    GetAgentOnly(AgentId: string) {
        return this.http.get('Agent/GetAgentOnly?AgentId=' + AgentId);
    }
    CheckNationalId(NationalId: string) {
        return this.http.get('Agent/CheckNationalId?NationalId=' + NationalId);
    }
    CheckUpdateNationalId(NationalId: string,UserId:string) {
        return this.http.get('Agent/CheckNationalId?NationalId=' + NationalId+"&UserId="+ UserId);
    }
    UpdateAgent(user: User) {
        return this.http.post('Agent/Update', user);
    }
    UpdateProfile(user: User) {
        return this.http.post('Agent/UpdateProfile', user);
    }

    ActivateRepresentative(UserId: string) {
        return this.http.get('AgentRepresentative/Activate?UserId=' + UserId);
    }

    DeActivateRepresentative(UserId: string) {
        return this.http.get('AgentRepresentative/DeActivate?UserId=' + UserId);
    }

    RepresentativeList(pageIndex: number, pageSize: number, searchName: string, sortBy: string, sortDirection: string, userId: string) {
        return this.http.get('AgentRepresentative/GetList?pageIndex=' + pageIndex + '&pageSize=' + pageSize + '&searchName=' + searchName + '&sortBy=' + sortBy + '&sortDirection=' + sortDirection + '&AgentId=' + userId);
    }

    GetAgentsInfoByDisplayName(keyWord: string) {
        return this.http.get('Agent/GetAgentsInfoByDisplayName?keyWord=' + keyWord);
    }
    GetAgentsAllInfoByDisplayName(keyWord: string) {
      return this.http.get('Agent/GetAgentsAllInfoByDisplayName?keyWord=' + keyWord);
  }

    UpdateProfileNextStep(user: User) {
        return this.http.post('Agent/UpdateProfileNextStep', user);
    }
    CanApplyFeesRequest(userName) {
        return this.http.get('Agent/CanApplyFeesRequest?userName=' + userName);
    }
    CanApplyTransitRequest(userName,requestId) {
        return this.http.get('Agent/CanApplyTransitRequest?userName=' + userName+"&RequestId="+ requestId);
    }

    CanApplyUpdateAgentProfile(userName) {
        return this.http.get('Agent/CanApplyUpdateAgentProfile?userName=' + userName);
    }

    getAgentCurrency(agentId: string,CurrencyId : number) {
        return this.http.get('AgentCurrency/GetAgentCurrency?AgentId=' + agentId+"&CurrencyId="+ CurrencyId);
      }
}
